// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__3_V7U","skeleton":"Loading_skeleton__6fKRo","card":"Loading_card__g4lAV"};